import { STEP_CONSTANTS } from './step-constants';
var StepFoundation = /** @class */ (function () {
    function StepFoundation(_adapter) {
        var _this = this;
        this._adapter = _adapter;
        this._clickListener = function () { return _this._onClickListener(); };
        this._expansionContentSlotChangeListener = function (evt) { return _this._onExpansionContentSlotChange(evt); };
        this._expansionContentFocusInListener = function (evt) { return _this._onExpansionContentFocusIn(evt); };
        this._expansionContentFocusOutListener = function (evt) { return _this._onExpansionContentFocusOut(evt); };
    }
    StepFoundation.prototype.initialize = function () {
        this._adapter.initialize();
        this._adapter.attachRipple();
        this._applySelected();
        this._toggleIcon();
        if (this._vertical) {
            this._adapter.addExpansionPanel();
            this._adapter.addExpansionIcon();
            this._adapter.setClickListener(this._clickListener);
            this._adapter.setSlotListener(this._expansionContentSlotChangeListener);
            this._adapter.addExpansionPanelListener('focusin', this._expansionContentFocusInListener);
            this._adapter.addExpansionPanelListener('focusout', this._expansionContentFocusOutListener);
        }
        this._initialized = true;
    };
    StepFoundation.prototype.disconnect = function () {
        this._adapter.detatchRipple();
        this._adapter.removeClickListener(this._clickListener);
        this._adapter.removeSlotListener(this._expansionContentSlotChangeListener);
        this._adapter.removeExpansionPanelListener('focusin', this._onExpansionContentFocusIn);
        this._adapter.removeExpansionPanelListener('focusout', this._onExpansionContentFocusOut);
    };
    Object.defineProperty(StepFoundation.prototype, "index", {
        get: function () {
            return this._index;
        },
        set: function (value) {
            if (this._index !== value) {
                this._index = value;
                this._applyIndex();
                this._adapter.setHostAttribute(STEP_CONSTANTS.attributes.INDEX, value.toString());
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(StepFoundation.prototype, "editable", {
        get: function () {
            return this._editable;
        },
        set: function (value) {
            if (this._editable !== value) {
                this._editable = value;
                this._adapter.toggleHostAttribute(STEP_CONSTANTS.attributes.EDITABLE, value);
                this._applyEditable();
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(StepFoundation.prototype, "completed", {
        get: function () {
            return this._completed;
        },
        set: function (value) {
            if (this._completed !== value) {
                this._completed = value;
                this._adapter.toggleHostAttribute(STEP_CONSTANTS.attributes.COMPLETED, value);
                this._applyCompleted();
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(StepFoundation.prototype, "error", {
        get: function () {
            return this._error;
        },
        set: function (value) {
            if (this._error !== value) {
                this._error = value;
                this._adapter.toggleHostAttribute(STEP_CONSTANTS.attributes.ERROR, value);
                this._applyError();
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(StepFoundation.prototype, "selected", {
        get: function () {
            return this._selected;
        },
        set: function (value) {
            if (this._selected !== value) {
                this._selected = value;
                this._adapter.toggleHostAttribute(STEP_CONSTANTS.attributes.SELECTED, value);
                this._applySelected();
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(StepFoundation.prototype, "alternative", {
        get: function () {
            return this._alternative;
        },
        set: function (value) {
            if (this._alternative !== value) {
                this._alternative = value;
                this._adapter.toggleHostAttribute(STEP_CONSTANTS.attributes.ALTERNATIVE, value);
                this._applyAlternative();
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(StepFoundation.prototype, "disabled", {
        get: function () {
            return this._disabled;
        },
        set: function (value) {
            this._disabled = value;
            this._applyDisabled();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(StepFoundation.prototype, "vertical", {
        get: function () {
            return this._vertical;
        },
        set: function (value) {
            if (value !== this._vertical) {
                this._vertical = value;
                this._applyVertical();
                if (this._initialized) {
                    if (this._vertical) {
                        this._adapter.addExpansionPanel();
                        this._adapter.addExpansionIcon();
                        this._adapter.setClickListener(this._clickListener);
                        this._adapter.setSlotListener(this._expansionContentSlotChangeListener);
                    }
                    else {
                        this._adapter.removeClickListener(this._clickListener);
                        this._adapter.removeSlotListener(this._expansionContentSlotChangeListener);
                        this._adapter.removeExpansionPanel();
                        this._adapter.removeExpansionIcon();
                    }
                }
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(StepFoundation.prototype, "expanded", {
        get: function () {
            return this._expanded;
        },
        set: function (value) {
            if (value !== this._expanded) {
                this._expanded = value;
                this._adapter.toggleHostAttribute(STEP_CONSTANTS.attributes.EXPANDED, this._expanded);
                if (this._initialized) {
                    this._applyExpanded();
                }
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(StepFoundation.prototype, "ignoreUserExpansion", {
        get: function () {
            return this._ignoreUserExpansion;
        },
        set: function (value) {
            if (value !== this._ignoreUserExpansion) {
                this._ignoreUserExpansion = value;
            }
        },
        enumerable: true,
        configurable: true
    });
    StepFoundation.prototype.setStepTabIndex = function (index) {
        this._adapter.setRootTabIndex(index);
    };
    StepFoundation.prototype._applyExpanded = function () {
        this._adapter.setExpanded(this._expanded);
    };
    StepFoundation.prototype._applyVertical = function () {
        this._adapter.toggleHostAttribute(STEP_CONSTANTS.attributes.VERTICAL, this._vertical);
        this._adapter.toggleRootClass(STEP_CONSTANTS.classes.VERTICAL, this._vertical);
    };
    StepFoundation.prototype.focus = function () {
        this._adapter.focusButton();
    };
    StepFoundation.prototype._applyAlternative = function () {
        this._adapter.toggleRootClass(STEP_CONSTANTS.classes.ALTERNATIVE, this._alternative);
    };
    StepFoundation.prototype._applySelected = function () {
        this._adapter.toggleRootClass(STEP_CONSTANTS.classes.SELECTED, this._selected);
        this._adapter.setHostAttribute(STEP_CONSTANTS.attributes.ARIA_SELECTED, (this._selected || false).toString());
        this._adapter.setRootTabIndex(this._selected ? 0 : -1);
        this._toggleIcon();
    };
    StepFoundation.prototype._applyIndex = function () {
        this._adapter.setIndex(this._index);
    };
    StepFoundation.prototype._applyEditable = function () {
        this._adapter.toggleRootClass(STEP_CONSTANTS.classes.EDITABLE, this._editable);
        this._toggleIcon();
    };
    StepFoundation.prototype._applyCompleted = function () {
        this._adapter.toggleRootClass(STEP_CONSTANTS.classes.COMPLETED, this._completed);
        this._toggleIcon();
    };
    StepFoundation.prototype._applyError = function () {
        this._adapter.toggleRootClass(STEP_CONSTANTS.classes.ERROR, this._error);
        this._toggleIcon();
    };
    StepFoundation.prototype._applyDisabled = function () {
        this._adapter.toggleDisabled(this._disabled);
        this._toggleIcon();
    };
    StepFoundation.prototype._getIconState = function () {
        if (this._error) {
            return 'warning';
        }
        if (this._completed) {
            if (this._editable) {
                return 'mode_edit';
            }
            return 'check';
        }
        if (this._editable && this._selected && !this._disabled) {
            return 'mode_edit';
        }
        if (this._disabled) {
            return 'block';
        }
        return '';
    };
    StepFoundation.prototype._toggleIcon = function () {
        this._iconState = this._getIconState();
        this._adapter.toggleIcon(this._iconState, this._iconState !== '');
    };
    StepFoundation.prototype._toggleExpanded = function () {
        if (this._adapter.slotHasContent()) {
            this._expanded = !this._expanded;
            this._applyExpanded();
            this._adapter.toggleHostAttribute(STEP_CONSTANTS.attributes.EXPANDED, this._expanded);
        }
    };
    StepFoundation.prototype._onClickListener = function () {
        if (this._vertical && !this._ignoreUserExpansion) {
            this._toggleExpanded();
        }
    };
    StepFoundation.prototype._onExpansionContentSlotChange = function (evt) {
        var hasSlotContent = this._adapter.slotHasContent();
        if (hasSlotContent) {
            this._adapter.setHostAttribute(STEP_CONSTANTS.attributes.EXPANDABLE);
            this._applyExpanded();
            // The animations on the initial slot content  is causing the panel not to open correctly. Opting out for animations on initialization
            this._adapter.setExpansionPanelAnimations(true);
        }
        else {
            this._adapter.removeHostAttribute(STEP_CONSTANTS.attributes.EXPANDABLE);
            this._adapter.setExpansionPanelAnimations(false);
        }
        this._adapter.toggleRootClass(STEP_CONSTANTS.classes.EXPANDABLE, hasSlotContent);
    };
    StepFoundation.prototype._onExpansionContentFocusIn = function (event) {
        if (!this._expandedContentFocused && this._adapter.isExpandedContentInFocus(event.target)) {
            this._adapter.emitHostEvent(STEP_CONSTANTS.events.EXPANDED_CONTENT_FOCUSIN, this._adapter.component);
            this._expandedContentFocused = true;
        }
    };
    StepFoundation.prototype._onExpansionContentFocusOut = function (event) {
        if (event.relatedTarget && !this._adapter.isExpandedContentInFocus(event.relatedTarget)) {
            this._adapter.emitHostEvent(STEP_CONSTANTS.events.EXPANDED_CONTENT_FOCUSOUT, this._adapter.component);
            this._expandedContentFocused = false;
        }
    };
    return StepFoundation;
}());
export { StepFoundation };
